// src/pages/admin/AdminStats.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firestore';
import Spinner from '../../Components/Spinner';

const AdminStats = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'orders'));
        const data = snapshot.docs.map(doc => doc.data());
        setOrders(data);
      } catch (err) {
        console.error('Error loading orders:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) return <Spinner />;

  const totalOrders = orders.length;
  const totalRevenue = orders.reduce((sum, order) => sum + (parseFloat(order.total) || 0), 0);
  const uniqueUsers = new Set(orders.map(o => o.userId)).size;

  return (
    <div className="max-w-4xl mx-auto mt-8 text-text space-y-6">
      <h1 className="text-3xl font-bold">Order Statistics</h1>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 className="text-xl font-semibold">Total Orders</h2>
          <p className="text-2xl">{totalOrders}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 className="text-xl font-semibold">Total Revenue</h2>
          <p className="text-2xl">{totalRevenue.toFixed(2)} €</p>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 className="text-xl font-semibold">Unique Users</h2>
          <p className="text-2xl">{uniqueUsers}</p>
        </div>
      </div>
    </div>
  );
};

export default AdminStats;
